import { useState } from 'react';

/**
 * Per-device "Show serving sizes" preference. Gates the serving-size column
 * (e.g. "2.5×60g (serving)") on each meal item + add-on in the food-log
 * timeline. ON by default; toggled on the Profile page.
 *
 * Read-on-mount is enough (no live cross-page sync needed): the toggle lives
 * on Profile and the log remounts when the clinician returns to a patient tab,
 * so it always picks up the current value.
 */
const STORAGE_KEY = 'ui.showServingSize';

export const readShowServingSize = (): boolean => {
  if (typeof window === 'undefined') return true;
  try {
    // Default ON: anything other than an explicit '0' counts as shown.
    return window.localStorage.getItem(STORAGE_KEY) !== '0';
  } catch {
    return true;
  }
};

export const useShowServingSize = (): [boolean, (next: boolean) => void] => {
  const [value, setValue] = useState<boolean>(readShowServingSize);
  const set = (next: boolean) => {
    setValue(next);
    try {
      window.localStorage.setItem(STORAGE_KEY, next ? '1' : '0');
    } catch {
      /* private mode / quota — ignore */
    }
  };
  return [value, set];
};
